module.exports = __webpack_public_path__ + "static/img/hero-book-bg.d67f426b.png";